import { themeGet } from 'styled-system'
import styled from 'styled-components'

export const Container = styled.div`
  padding: 0.1875rem 1rem 0.4375rem;
  margin-bottom: 1.5rem;
  border-radius: 0.3125rem;
  border: 0.125rem solid
    ${props =>
      props.siteChangeChecked
        ? themeGet('colors.successGreen')
        : themeGet('colors.errorLightRed')};
`



// WEBPACK FOOTER //
// ./src/components/EditLicenseModalSiteChangeConfirmation/component.styles.js